module.exports = __webpack_public_path__ + "img/info.7e0d57a3.svg";